<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Eejirw/tc-custom/9781545811771.jpg?1714418549000" alt="This image is the cover for the book Crusader #2"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Crusader #2
      </h1>
      <p class="bookDescription body article font2">
        <p>On the way to a human stronghold Grimbel knows of, the Crusader and Grimbel come face to face with The Masters’ henchman, Pilgrim. Between the town guards, Pilgrim, and his own temper, the Crusader might be even more lost than when he arrived.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Matt Emmons
      </h2>
      
      <p class="authorDescription body article">Matt Emmons is a comics artist based in Philadelphia. Raised on a healthy diet of 80's monster movies, he spends much of his time drawing creatures that feature mostly as the main characters of his own comics. His work has been published by Heavy Metal Magazine, Metal Hurling, and Comixology Originals, along with several self published titles.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?618a27fc